import Vue from 'vue'
import Vuex from 'vuex'
// import createPersistedState from "vuex-persistedstate"
import login from './modules/login'
import home from './modules/home'
import menu from './modules/menu'

Vue.use(Vuex)

const state = {
    rootValue: 54,
    language: localStorage.getItem('language') || 'zh',
    metaInfo:{},
    runenv:"",//miniprogram 小程序
    
}

const mutations = {
    SET_LANGUAGE(state, language) {
        state.language = language;
        localStorage.setItem('language', language);
    },
    CAHNGE_META_INFO(state,metaInfo){
        state.metaInfo=metaInfo;
    },
    SET_ENV(state, runenv) {
        state.runenv = runenv;
    },

}

const actions = {
    toggleLanguage({ commit }) {
        commit('SET_LANGUAGE',store.state.language === 'en' ? 'zh' : 'en');
    }
}

const getters = {
    language: state => state.language,
    navigationList:state => state.menu.navigationList,
    categoryList :state => state.menu.categoryList,
    categoryObj :state => state.menu.categoryObj,
    footData:state => state.menu.footData,
    configData:state => state.menu.configData,
    runenv:state => state.runenv,
}

const modules = {
    login,
    home,
    menu,
}

const store = new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    modules,
    // plugins: [createPersistedState({ storage: window.sessionStorage })]  //缓存到sessionStorage
})

export default store